module.exports = __webpack_public_path__ + "static/media/DooExchange.c93d73af.svg";